import { render, staticRenderFns } from "./CardTarjaHexaNeles.vue?vue&type=template&id=6d791f6c&scoped=true"
import script from "./CardTarjaHexaNeles.vue?vue&type=script&lang=js"
export * from "./CardTarjaHexaNeles.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaHexaNeles.vue?vue&type=style&index=0&id=6d791f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d791f6c",
  null
  
)

export default component.exports